import { apiInstance } from "@core/api/axios/apiInstance";
import { parseSchema } from "@core/model/parseSchema";

import { secedeICafeListSchema, type SecedeICafeListType } from "@features/account/model";

/**
 * 피씨방 삭제 신청 목록
 * @param signal
 */
export const fetchSecedeICafeList = async (signal?: AbortSignal): Promise<SecedeICafeListType | null> => {
  const res = await apiInstance.get("/account/me/secede", { signal });

  return parseSchema<SecedeICafeListType>({
    schema: secedeICafeListSchema,
    rawData: res?.data,
  });
};
